import { mapFilespaceFormatToVersion, StorageCredentialsType, } from '@lucidlink/dto/validation';
import { arrayToBase64, encryptCryptoKeyWithPublicKey, exportPublicCryptoKeyToPem, generateEncryptPair, } from '@lucidlink/ts-crypto/crypto';
import { createClientSideFsInitializer } from '@lucidlink/web-fs/filespace';
export const prepareFilespaceCreateCrypto = async (adminCrypto, filespaceFormat) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const workspaceCommonKey = await adminCrypto.getWorkspaceCommonKeyArray();
    const filespaceRootKeys = await generateEncryptPair();
    const clientInitializer = createClientSideFsInitializer();
    const filespaceVersion = mapFilespaceFormatToVersion(filespaceFormat);
    const cryptoParams = await clientInitializer.prepareInitParams(await exportPublicCryptoKeyToPem(filespaceRootKeys.publicKey), new Uint8Array(workspaceCommonKey), 
    // The initializer provisions the Lost&Found rescue tree itself for versions that carry it.
    { version: filespaceVersion });
    const eFilespaceRootPrivateKeyByAdminKeyPromise = encryptCryptoKeyWithPublicKey(filespaceRootKeys.privateKey, adminKeys.encryptPair.publicKey);
    // The initializer produces the Lost&Found rescue-tree material exactly for versions that
    // carry it (V13+); only the creator holds the keys to build it, so it must travel with the
    // create request for the hub-side initializer to assemble and commit the tree.
    const lostAndFoundCryptoParams = cryptoParams.lostAndFound
        ? {
            lostAndFound: {
                dirNameHmac: arrayToBase64(cryptoParams.lostAndFound.dirNameHmac),
                dirFwdValue: arrayToBase64(cryptoParams.lostAndFound.dirFwdValue),
                subdirNameHmac: arrayToBase64(cryptoParams.lostAndFound.subdirNameHmac),
                subdirFwdValue: arrayToBase64(cryptoParams.lostAndFound.subdirFwdValue),
                encryptedCryptoKey: arrayToBase64(cryptoParams.lostAndFound.encryptedCryptoKey),
                filespaceAdminPublicKey: cryptoParams.lostAndFound.filespaceAdminPublicKey,
            },
        }
        : {};
    return {
        eFilespaceRootPrivateKeyByAdminKey: await eFilespaceRootPrivateKeyByAdminKeyPromise,
        initCryptoParams: {
            encryptedRootFolderAccess: arrayToBase64(cryptoParams.encryptedRootFolderAccess),
            encryptedCommonConfigKey: arrayToBase64(cryptoParams.encryptedCommonConfigKey),
            unencryptedCommonConfigKey: arrayToBase64(cryptoParams.unencryptedCommonConfigKey),
            ...lostAndFoundCryptoParams,
        },
    };
};
export const prepareFilespaceCreate = async (params, adminCrypto) => {
    return {
        ...params,
        storageAccessKeyId: params.storageAccessKeyId,
        storageSecretAccessKey: params.storageSecretAccessKey,
        storageCredentialsType: params.storageCredentialsType ?? StorageCredentialsType.ACCESS_KEY,
        ...(await prepareFilespaceCreateCrypto(adminCrypto, params.filespaceFormat)),
    };
};
